import { axios } from "@v2/shared/api";
const FEEDBACK_ENDPOINT = "feedbacks";
const AUTH_ENDPOINT = "auth";
const LANGUAGE_ENDPOINT = "language";

export default {
  setLocale(locale) {
    return axios.post(LANGUAGE_ENDPOINT, { locale });
  },

  authorize(email, password) {
    return axios.post(`${AUTH_ENDPOINT}/login`, {
      email,
      password
    });
  },

  logout() {
    return axios.get(`${AUTH_ENDPOINT}/logout`);
  },

  confirm(id, hash) {
    return axios.get(`${AUTH_ENDPOINT}/verify-email/${id}/${hash}`);
  },

  async get() {
    return axios.get(`${AUTH_ENDPOINT}/user`);
  },

  update(data) {
    return axios.put(`${AUTH_ENDPOINT}/user`, data);
  },

  emailNotificationsUpdate(data) {
    return axios.put(`${AUTH_ENDPOINT}/user/email-notifications`, data);
  },

  restorePassword(email) {
    return axios.post(`${AUTH_ENDPOINT}/forgot-password`, {
      email
    });
  },

  changeLostPassword(data) {
    return axios.post(`${AUTH_ENDPOINT}/update-password`, data);
  },

  changePassword(old_password, new_password, new_password_confirmation) {
    return axios.put(`${AUTH_ENDPOINT}/user/change-password`, {
      old_password,
      new_password,
      new_password_confirmation
    });
  },

  feedback({ name, message, email, phone }) {
    return axios.post(`${FEEDBACK_ENDPOINT}`, {
      email,
      name,
      message,
      phone
    });
  },
  completeRegister(userId, data) {
    return axios.post(
      `welcome/${userId}?signature=${data.signature}&expires=${data.expires}`,
      {
        name: data.firstName,
        lastname: data.lastName,
        middlename: data.middleName,
        phone: data.phoneNumber.replace(/[\s+]/gi, ""),
        password: data.password,
        password_confirmation: data.passwordConfirmation,
        can_send_notifications: data.notifications || 0
      }
    );
  }
};
